import { autoUpdate, offset, size, useFloating } from '@floating-ui/react-dom';

import { FLOATING_PLACEMENT } from 'src/data/ui';

import { expandPadding } from '../../utils';

import { SPOTLIGHT_TYPE } from './const';

export const useSpotlightFloating = ({ referenceElement, floatingElement, options }) => {
  return useFloating({
    elements: {
      reference: referenceElement,
      floating: floatingElement,
    },
    placement: FLOATING_PLACEMENT.bottom,
    middleware: [
      offset(({ rects }) => {
        const paddings = expandPadding(options.padding);
        const skidding = (paddings.right - paddings.left) / 2;

        // We need this offset, cause spotlight has initial "bottom" placement
        const verticalOffset = -0.5 * (rects.floating.height + rects.reference.height);
        const distance = verticalOffset + (paddings.bottom - paddings.top) / 2;

        return {
          mainAxis: distance,
          crossAxis: skidding,
        };
      }, options),

      size({
        apply({ rects, elements }) {
          const { width, height } = rects.reference;

          const size = calcSpotlightSize(options, width, height);

          elements.floating.style.width = `${size.width}px`;
          elements.floating.style.height = `${size.height}px`;
        },
      }),
    ],
    whileElementsMounted: autoUpdate,
  });
};

const calcSpotlightSize = (options, elementWidth, elementHeight) => {
  const paddings = expandPadding(options.padding);
  const isCircle = options.type === SPOTLIGHT_TYPE.circle;

  let width = elementWidth + paddings.left + paddings.right;
  let height = elementHeight + paddings.top + paddings.bottom;
  if (isCircle) {
    width = Math.max(width, height);
    height = Math.max(width, height);
  }

  return { width, height };
};
